import commonDisplayImagesTextResultGridCSS from '@assets/css/common-display-images-text-result-grid.css';

/**
 * Common display images text result grid styles.
 * @type {CSSStyleSheet}
 */
export const commonDisplayImagesTextResultGridStyles = new CSSStyleSheet();
commonDisplayImagesTextResultGridStyles.replaceSync(commonDisplayImagesTextResultGridCSS);
